import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
  standalone: true,
  pure: true
})
export class TruncatePipe implements PipeTransform {
  transform(
    value: string | null | undefined,
    limit = 20,
    suffix = '…'
  ): string {
    if (!value) return '';
    if (value.length <= limit) return value;

    return value.substring(0, limit).trimEnd() + suffix;
  }
}
